import React from "react";
import {
  Col,
  Row,
  Button,
} from "reactstrap";
import Table from "../../../components/Table/Table";
import "../../../assets/sass/_common.scss";
import SweetAlert from "../../../components/sweet-alert/SweetAlert";
import SectionFilter from "./component/Filter"
import {
  deleteSecion,
  activeInActiveSection,
  filterTableRecords,
} from "./apiCalls";
import { notificationAction } from "../../../redux/reducers/notification_reducer";
import * as ActionTypes from "../../../redux/actions/types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { MdEdit, MdOutlineCategory } from "react-icons/md";
import { MdDelete } from "react-icons/md";
import LoadingMask from "../../../components/Loader/LoadingMask";

class Section extends React.Component {
    state = {
      sweetalert: false,
      paginationData:[],
      secId: null,
      download: true,
      allChecked: false,
      appLoadingState: false,
      sectionList: [],
      selectedDetailInfo: {},

      selectedSectionValues: {
        name: null,
        is_active: null
      },
      selectedValues: {
        selected_is_active: { label: "All", value: -1 },
      },
  }

  componentDidMount() {
    this.props.RecordPerPage(10)
    this.props.PageNo(1)
    this.handleFilterDataTableList();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.pageno !== this.props.pageno ||
      prevProps.sortname !== this.props.sortname ||
      prevProps.sortby !== this.props.sortby
    ) {
      this.handleFilterDataTableList();
    }
    if (prevProps.recordperpage !== this.props.recordperpage) {
      this.props.PageNo(1);
      this.handleFilterDataTableList();
      this.setState({
        allChecked: false,
      });
    }
  }

  handleFiltersClear = () => {
    this.props.PageNo(1);
    this.props.RecordPerPage(10);
    this.setState(
      {
        selectedSectionValues: {
          name: "",
         
        },
        selectedValues: {
          selected_is_active: { label: "All", value: -1 },
        },
      },
      () => this.handleFilterDataTableList()
    );
  };


  handleFilterApply = () => {
    this.handleFilterDataTableList();
  };

  handleFilterDataTableList = () => {


    this.setState({ appLoadingState: true })
    const { selectedSectionValues ,selectedValues} = this.state;
    const {selected_is_active}=selectedValues;
    const {
      name,
      is_active
    } =
      selectedSectionValues;
    filterTableRecords(
      this.props.recordperpage ? this.props.recordperpage : null,
      this.props.pageno ? this.props.pageno : null,
      this.props.sortname ? this.props.sortname : null,
      this.props.sortby ? this.props.sortby : null,
      name ? name.replace(/^\s+|\s+$/g, "") : null,
      selected_is_active.label !== "All" ? (is_active ? "1" : "0") : null,
    )
      .then((response) => {
        if (response.code == 200) {
          this.setState({
            sectionList: response.data.dataset,
            paginationData: response.data.pagination,
            appLoadingState: false

          });
        }
        else if (response.code != 200){
          const info = {
            message: response.message,
            status: "error",
          };
          this.props.notificationAction(info);
          this.setState({
            appLoadingState: false,
          });
        }
      })
      .catch((error) => console.log("Erorr in getting students ", error));
  };

  validateField = ({ name, value }) => {
    const { selectedSectionValues } = this.state;
    this.setState({
      selectedSectionValues: {
        ...selectedSectionValues,
        [name]: value,
      },
    });
  };

  handleFormFieldChange = (e) => {
    const { name, value } = e.target;
    if (name === "name" ) {
      this.validateField({ name, value });
      return;
    }
  };
  
  handelDropDownChange = (selectedOption, obj) => {
    const { selectedValues, selectedSectionValues } = this.state;
    const { name } = obj;
    if (!selectedOption) {
      let defaultOption = { value: "", label: "All" };
      if (
        obj.name === "is_active"
      ) {
        this.setState({
          selectedValues: {
            ...selectedValues,
            [`selected_${obj.name}`]: defaultOption,
          },
          selectedSectionValues: {
            ...selectedSectionValues,
            [name]: null,
          },
        });
      }
      return;
    }
else {
      this.setState({
        selectedValues: {
          ...selectedValues,
          [`selected_${name}`]: selectedOption,
        },
        selectedSectionValues: {
          ...selectedSectionValues,
          [name]: selectedOption.value,
        },
      });
    }
  };

  handleCheckOptionToggle = (item) => {
    if (item != null) {
      this.setState({
        allChecked: false,
        sectionList: this.state.sectionList.map((s) =>
          s.id == item.id ? { ...item, Checked: !s.Checked } : s
        ),
      });
    } else {
      this.setState({
        allChecked: !this.state.allChecked,
        sectionList: this.state.sectionList.map((s) => ({
          ...s,
          Checked: !this.state.allChecked,
        })),
      });
    }
  };

  handleTableButtonClick = (item, type) => {

    if (type == "Edit") {

      this.handleSectionEdit({
        selectedSection: item,
      });
    } else if (type == "Delete") {
      this.handleSectiondelete(item.id);

    }
  };

  handleToggleButtonClick = (item) => {
    let allSectionList = this.state.sectionList;
    let studentMapping = allSectionList.find(function (element) {
      return element.id == item.id;
    });
    let studentStatus = null;
    if (studentMapping.status == 1) {
      studentStatus = 0;
    } else if (studentMapping.status == 0) {
      studentStatus = 1;
    }

    let statusData = {
      section_id: [studentMapping.id],
      status: studentStatus,
    };
    activeInActiveSection({ statusData })
      .then((response) => {
        if (response.code === 200) {
          const info = {
            message: response.message,
            status: "success",
          };
          this.props.notificationAction(info);
          this.handleFilterDataTableList();
          return;
        }
      })
      .catch((error, response) => {
        const info = {
          message: response.message,
          status: "error",
        };
        this.props.notificationAction(info);
      });
  };
  handleSectionEdit = (item) => {
    console.log(item)
    this.props.history.push({
      pathname: "/lookups/section/edit-section/" + item.selectedSection.id,
      state: {
        selectedDetailInfo: item.selectedSection,
      },
    });
  };
  handelSweetModalDelete = (e) => {
    let statusData = { section_id: [this.state.secId] };
    if (e) {
      deleteSecion({ statusData })
        .then((response) => {
          if (response.code === 200) {
            const info = {
              message: response.message,
              status: "success",
            };
            this.setState({
              sweetalert: false
            })
            this.props.notificationAction(info);
            this.handleFilterDataTableList();
            return;
          }
         else if (response.code != 200) {
            const info = {
              message: response.message,
              status: "error",
            };
            this.setState({
              allChecked: false,
              sweetalert: false
            })
            this.props.notificationAction(info);
            this.handleFilterDataTableList();
            return;
          }
        })
        .catch((error, response) => {
          const info = {
            message: response.message,
            status: "error",
          };
          this.props.notificationAction(info);
        });
    }
    else {
      this.setState({
        sweetalert: false
      })
    }

  }
  handleSectiondelete = (Id) => {
    this.setState({
      secId: Id,
      sweetalert: true
    })
  };
  handleGettingBulkRecord = (item) => {
    const listArray = [];
    item.data.map((item) => {
        listArray.push(item.id);
    });
    let statusData = {
      section_id: listArray,
      status: item.status,
    };
    if (item.status == "delete") {
      let statusData = {
        section_id: listArray
      };
      deleteSecion({ statusData })
        .then((response) => {
          if (response.code === 200) {
            const info = {
              message: response.message,
              status: "success",
            };
            this.props.notificationAction(info);
            this.handleFilterDataTableList();
            this.setState({
              allChecked: false,
            });
            return;
          }
        })
        .catch((error, response) => {
          const info = {
            message: response.message,
            status: "error",
          };
          this.props.notificationAction(info);
        });
    } else if (item.status == "0") {
      activeInActiveSection({ statusData })
        .then((response) => {
          if (response.code === 200) {
            const info = {
              message: response.message,
              status: "success",
            };
            this.props.notificationAction(info);
            this.handleFilterDataTableList();
            this.setState({
              allChecked: false,
            });
            return;
          }
        })
        .catch((response) => {
          const info = {
            message: response.message,
            status: "error",
          };
          this.props.notificationAction(info);
        });
    } else if (item.status == "1") {
      activeInActiveSection({ statusData })
        .then((response) => {
          if (response.code === 200) {
            const info = {
              message: response.message,
              status: "success",
            };
            this.props.notificationAction(info);
            this.handleFilterDataTableList();
            this.setState({
              allChecked: false,
            });
            return;
          }
        })
        .catch((response) => {
          const info = {
            message: response.message,
            status: "error",
          };
          this.props.notificationAction(info);
        });
    }
  };
  handleExportCsv = () => {
  this.setState({ appLoadingState: true });
    const { download,selectedValues} = this.state;
    const { selected_is_active } = selectedValues;
    const {
      name,
      is_active
    } =
      this.state.selectedSectionValues;
    filterTableRecords(
      this.props.recordperpage ? this.props.recordperpage : null,
      this.props.pageno ? this.props.pageno : null,
      this.props.sortname ? this.props.sortname : null,
      this.props.sortby ? this.props.sortby : null,
      name ? name.replace(/^\s+|\s+$/g, "") : null,
      selected_is_active.label !== "All" ? (is_active ? "1" : "0") : null,
      download ? 1 : null
    )
      .then((response) => {
        if (response.code == 200) {
          if (response.data.file_url != null) {
            window.open(response.data.file_url, "_blank");
          }
        }
        this.setState({ appLoadingState: false });
      })
      .catch((error) => console.log("Erorr in getting locations ", error));
  };


  render() {
    let template;

    template = (
      <div>
        <Row>
          {this.state.appLoadingState ? <LoadingMask /> : null}
          <Col md={3} lg={3}>
           

          </Col>
          <Col md={9} lg={9}>
          <SweetAlert show={this.state.sweetalert}
              deleteRecord={this.handelSweetModalDelete}
            />

            <Link to="/lookups/section/add-section">
              <Button color="primary" className="pull-right  button-full-width">
                <MdOutlineCategory /> &nbsp; Add Section
              </Button>
            </Link>
          </Col>
        </Row>
        <SectionFilter
          onFilterApply={this.handleFilterApply}
          onExportCsv={this.handleExportCsv}
          SelectedValues={this.state.selectedValues}
          selectedFormValues={this.state.selectedSectionValues}
          onFormFieldChange={this.handleFormFieldChange}
          onDDChange={this.handelDropDownChange}
          onFilterReset={this.handleFiltersClear}
        />
        <Row>
          <Col className="pr-grid-col" xs={12} lg={12}>
            {this.state.sectionList && this.state.sectionList.length > 0 ? (
              <Table
                primaryKeyField="sno"
                data={this.state.sectionList}
                isImageEnabled={false}
                listItemToDisplay={[
                  { name: "Section Name", valueField: "name" },
                  { name: "Short Code", valueField: "code" },
                  { name: "Modified", valueField: "updated_at" },
                ]}
                onCheckOptionToggle={this.handleCheckOptionToggle}
                isCheckOption={true}
                allChecked={this.state.allChecked}
                paginationData={this.state.paginationData}
                toggleButtonToDisplay={true}
                buttonsToDisplay={[
                  {
                    name: "Edit",
                    buttonLabel: "Edit",
                    icon: <MdEdit size={22} />,
                    Tooltipmessage: "Edit Section"
                  },
                  {
                    name: "Delete",
                    color: "#CE3939",
                    icon: <MdDelete size={22} />,
                    buttonLabel: "Delete",
                    Tooltipmessage: "Delete Section"
                  },
                ]}
                onTableButtonClick={this.handleTableButtonClick}
                onToggleStatus={this.handleToggleButtonClick}
                onGettingBulkRecords={this.handleGettingBulkRecord}

              />
            ) : (
              <div className="text-center">
                There is no data available to show
              </div>
            )}
          </Col>
        </Row>
      </div>
    );

    return  (
      <div className="">{template} </div>
    );
  }
}

const actions = (dispatch) => ({
  notificationAction: (message, status) =>
    dispatch(notificationAction(message, status)),
  RecordPerPage: (recordperpage) =>
    dispatch({ type: ActionTypes.RECORDS_PER_PAGE, recordperpage }),
  PageNo: (pageno) => dispatch({ type: ActionTypes.PAGE_NO, pageno }),
});
const mapStateToProps = (state) => ({
  pageno: state.tab.pageno,
  recordperpage: state.tab.recordperpage,
  sortby: state.tab.sortBy,
  sortname: state.tab.sortName,
});

export default connect(mapStateToProps, actions)(Section);
